import type { Order } from "../models/order";
import { purchaseEvent } from "../tracking/events";
import { clearGaUserType, readGaUserType } from "./ga-user-type";
import { consumeVdItemListIds } from "./vd-item-list-ids";

// REV-125: pushes the B2B voucher `purchase`. Consumes the checkout's sessionStorage attribution
// (item list ids, user type), so call it only after the backend granted the purchase claim.
export const emitVouchersPurchase = (order: Order, { orderFor }: { orderFor?: string } = {}) => {
  const itemListIds = consumeVdItemListIds();
  const userType = readGaUserType();
  const totalValue = Number(order.totalGrossPrice);

  purchaseEvent(
    order.items.map((item) => ({
      ...item,
      productType: "blood-test-package",
      uuid: item.productUuid,
      quantity: 1,
      ...(itemListIds[item.productUuid] && { item_list_id: itemListIds[item.productUuid] }),
    })),
    { value: totalValue, transactionId: order.uuid },
    {
      paymentType: totalValue === 0 ? "free" : "PayU",
      ...(orderFor !== undefined && { orderFor }),
      numberOfProducts: order.items.length,
      userType,
    },
  );

  // Mirrors GAO TYP: clear once purchase fired so a stale userType doesn't leak into later journeys.
  clearGaUserType();
};
